import { create } from 'zustand'

interface BasketStateStore {
  addingItem: boolean
  updatingItem: boolean
  removingItem: boolean
  setAddingItem: (loading: boolean) => void
  setUpdatingItem: (loading: boolean) => void
  setRemovingItem: (loading: boolean) => void
}

export const useBasketStateStore = create<BasketStateStore>((set) => ({
  addingItem: false,
  updatingItem: false,
  removingItem: false,
  setAddingItem: (loading: boolean) => set({ addingItem: loading }),
  setUpdatingItem: (loading: boolean) => set({ updatingItem: loading }),
  setRemovingItem: (loading: boolean) => set({ removingItem: loading }),
}))
